module.exports = __webpack_public_path__ + "static/ensemada-413650b48b55e885ec2aa1cb764aef1e.jpg";